import { AutoProduct } from 'src/enums/AutoProduct'
import axios from 'axios'
import { cleanRegNo } from '@utils/giCar/registrationValidation'
import { getTurnstileToken, isTurnstileEnabledForProduct } from '@utils/turnstile/turnstile'

export const AUTO_PROPOSAL_API_URL = '/motororchestrator/api/v2/proposals'
export const AUTO_PROPOSAL_TIMEOUT_MS = 15000

export interface AutoProposalSubmitParams {
  product: AutoProduct
  registrationNumber: string
  mobileNumber?: string
  origin?: string
  turnstileConfig?: Parameters<typeof getTurnstileToken>[0]
  url?: string
  timeout?: number
}

export interface AutoProposalPayload {
  registration_number: string
  mobile_no: string
  origin: string
  product: AutoProduct
  is_new: false
}

export const getAutoProposalOrigin = (product: AutoProduct) => (product === AutoProduct.Bike ? 'acko_bike' : 'acko')

export const buildAutoProposalPayload = ({
  product,
  registrationNumber,
  mobileNumber = '',
  origin = getAutoProposalOrigin(product),
}: AutoProposalSubmitParams): AutoProposalPayload => ({
  registration_number: cleanRegNo(registrationNumber),
  mobile_no: mobileNumber,
  origin,
  product,
  is_new: false,
})

export const submitAutoProposal = async ({
  product,
  turnstileConfig,
  url = AUTO_PROPOSAL_API_URL,
  timeout = AUTO_PROPOSAL_TIMEOUT_MS,
  ...params
}: AutoProposalSubmitParams) => {
  const shouldValidateTurnstile = isTurnstileEnabledForProduct(turnstileConfig, product)
  const turnstileToken =
    shouldValidateTurnstile && turnstileConfig
      ? await getTurnstileToken(turnstileConfig)
      : null

  const response = await axios.request({
    method: 'post',
    url,
    headers: {
      'X-Landing-URL': typeof window !== 'undefined' ? window.location?.href : '/',
      'X-Landing-Path': '/',
      'x-app-name': 'frontend-seo',
      'x-platform': 'mweb',
      ...(turnstileToken ? { 'x-turnstile-token': turnstileToken } : {}),
    },
    data: buildAutoProposalPayload({ product, ...params }),
    timeout,
  })

  return response.data
}
